// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type { PowerBIProps } from './helsecorePowerBI.d'
import { PowerBI } from '@dip/helsecore/src/components/parts/PowerBI/PowerBI';
import React from 'react';

export default (props: Readonly<PowerBIProps>) => <PowerBI {...props} />

